import { DeterministicView } from '@bingads-webui/deterministic-view';
import template from './information-template.pug';

export const getHotelGroupInformationView = ({ i18n }) => {
  if (!i18n) {
    return {};
  }

  /**
   * Class representing an account information view for HotelCenter
   * @extends View
   */
  class HotelGroupInformationView extends DeterministicView {
    /**
    * Initializes AccountInformationView
    * Creates model and give default parameter for account information.
    * @returns { undefined }
    */
    initialize() {
      this.i18n = i18n;
    }
    get template() {
      return template;
    }

    get events() {
      return {
        'click .glyphicon-arrow-left': this.onBack,
        'click .hotel-group-information-remove__glyphicon': this.onRemove,
      };
    }

    onBack() {
      this.trigger('go-back');
    }

    onRemove() {
      this.trigger('remove-group-info');
    }
  }

  return {
    HotelGroupInformationView,
  };
};
